import StubPage from './StubPage';

export default StubPage;
